<template>
  <span class="lineItem"></span>
</template>
<script>
export default {
  
}
</script>
<style scoped>
.lineItem{
  width:20px;
  height:5px;
  background: #666666;
  border-radius: 5px;
  display: inline-block;
  margin-bottom: 30px;
}
</style>